module.exports = __webpack_public_path__ + "media/5.23b64322.mp4";